export const COUNTER_BLOCK = {
  LABEL:    'COUNTER_BLOCK',
  SETTINGS: {
    ANIMATION:        false,
    BACKGROUND_COLOR: null,
    COLUMNS_COUNT:    {
      ONE_COLUMN:    1,
      TWO_COLUMNS:   2,
      THREE_COLUMNS: 3,
      FOUR_COLUMNS:  4,
    },
  },
  FIELDS:   {
    COLUMNS_COUNT: null,
    CONTENT:       [],
  },
};

export const CITIES_BLOCK = {
  LABEL:  'CITIES_BLOCK',
  FIELDS: {
    CONTENT: [],
  },
};

export const DELIMITER_BLOCK         = {
  LABEL:    'DELIMITER_BLOCK',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
};
export const DOWNLOADABLE_CARD_BLOCK = {
  LABEL:    'DOWNLOADABLE_CARD_BLOCK',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    ALT:       '',
    BUTTON:    '',
    CONTENT:   null,
    IMAGE:     [],
    FILE:      [],
    FILE_LINK: null,
  },
};
export const TEXT_BLOCK              = {
  LABEL:    'TEXT_BLOCK',
  SETTINGS: {
    TEXT_TYPE:        {
      BASE_TEXT:        'BASE_TEXT',
      HIGHLIGHTED_TEXT: 'HIGHLIGHTED_TEXT',
      MUTED_TEXT:       'MUTED_TEXT',
    },
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    TEXT_TYPE: 'BASE_TEXT',
    CONTENT:   null,
  },
};
export const YOUTUBE_VIDEO           = {
  LABEL:    'YOUTUBE_VIDEO',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    AUTOPLAY: false,
    CONTENT:  null,
    LOOP:     false,
    MUTED:    false,
  },
};
export const HIGHLIGHTED_BLOCK       = {
  LABEL:  'HIGHLIGHTED_BLOCK',
  FIELDS: {
    LABEL:   null,
    CONTENT: null,
  },
};
export const TILES                   = {
  LABEL:    'TILES',
  SETTINGS: {
    BACKGROUND_COLOR: null,
    COLUMNS_COUNT:    {
      ONE_COLUMN:    1,
      TWO_COLUMNS:   2,
      THREE_COLUMNS: 3,
    },
  },
  FIELDS:   {
    COLUMNS_COUNT: null,
    CONTENT:       [],
  },
};
export const COLLAPSED_BLOCK         = {
  LABEL:    'COLLAPSED_BLOCK',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    LABEL:   null,
    CONTENT: [],
    IMAGES:  [],
  },
};
export const IMAGE                   = {
  LABEL:    'IMAGE',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    CONTENT: [],
    ALT:     '',
  },
};

export const TEXT_WITH_IMAGE = {
  LABEL:    'TEXT_WITH_IMAGE',
  SETTINGS: {
    BACKGROUND_COLOR: null,
    TEXT_POSITION:    'right',
  },
  FIELDS:   {
    IMAGE:   [],
    ALT:     '',
    CONTENT: null,
  },
};
export const IMAGE_GALLERY   = {
  LABEL:    'IMAGE_GALLERY',
  SETTINGS: {
    BACKGROUND_COLOR: null,
    SIZE:             {
      BASE_SIZE:        'BASE_SIZE',
      WIDE_SCREEN_SIZE: 'WIDE_SCREEN_SIZE',
    },
    CONTROLS:         {
      HIDDEN:   'HIDDEN',
      PREVIEWS: 'PREVIEWS',
      DOTS:     'DOTS',
    },
  },
  FIELDS:   {
    CONTENT:  [],
    SIZE:     'BASE_SIZE',
    CONTROLS: 'PREVIEWS',
  },
};

export const DOOR_SLIDER = {
  LABEL:    'DOOR_SLIDER',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    LABEL:  null,
    OFFERS: [],
    URL:    null,
  },
};

export const CARD = {
  LABEL:    'CARD',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    IMAGE:   [],
    ALT:     null,
    CONTENT: null,
  },
};

export const STB = {
  LABEL:    'STB',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    SERIES: null,
  },
};

export const GRID = {
  LABEL:              'GRID',
  SETTINGS:           {
    BACKGROUND_COLOR: null,
    COLUMNS_COUNT:    {
      ONE_COLUMN:    1,
      TWO_COLUMNS:   2,
      THREE_COLUMNS: 3,
      FOUR_COLUMNS:  4,
      FIVE_COLUMNS:  5,
      SIX_COLUMNS:   6,
      SEVEN_COLUMNS: 7,
      EIGHT_COLUMNS: 8,
    },
  },
  FIELDS:             {
    LABEL:   null,
    CONTENT: [],
  },
  ALLOWED_COMPONENTS: {
    DELIMITER_BLOCK,
    DOWNLOADABLE_CARD_BLOCK,
    TEXT_BLOCK,
    YOUTUBE_VIDEO,
    HIGHLIGHTED_BLOCK,
    COLLAPSED_BLOCK,
    IMAGE,
    TEXT_WITH_IMAGE,
    IMAGE_GALLERY,
  },
};

export const TABS = {
  LABEL:              'TABS',
  FIELDS:             {
    LABEL:   null,
    NAV:     [],
    CONTENT: [],
  },
  ALLOWED_COMPONENTS: {
    COUNTER_BLOCK,
    CARD,
    COLLAPSED_BLOCK,
    DELIMITER_BLOCK,
    DOWNLOADABLE_CARD_BLOCK,
    DOOR_SLIDER,
    HIGHLIGHTED_BLOCK,
    IMAGE,
    IMAGE_GALLERY,
    GRID,
    STB,
    TEXT_BLOCK,
    TEXT_WITH_IMAGE,
    TILES,
    YOUTUBE_VIDEO,
  },
};

export const BUTTON_TABS = {
  LABEL:              'BUTTON_TABS',
  FIELDS:             {
    TITLE:       null,
    DESCRIPTION: null,
    LABEL:       null,
    NAV:         [],
    CONTENT:     [],
  },
  SETTINGS:           {
    STYLE: {
      TABS:    'TABS',
      BUTTONS: 'BUTTONS',
      SELECT:  'SELECT',
    },
  },
  ALLOWED_COMPONENTS: {
    COUNTER_BLOCK,
    CARD,
    COLLAPSED_BLOCK,
    DELIMITER_BLOCK,
    DOWNLOADABLE_CARD_BLOCK,
    DOOR_SLIDER,
    HIGHLIGHTED_BLOCK,
    IMAGE_GALLERY,
    IMAGE,
    GRID,
    STB,
    YOUTUBE_VIDEO,
    TEXT_BLOCK,
    TEXT_WITH_IMAGE,
    TILES,
  },
};

export const TABS_WITH_ROUTER = {
  LABEL:              'TABS_WITH_ROUTER',
  FIELDS:             {
    TITLE:       null,
    DESCRIPTION: null,
    LABEL:       null,
    NAV:         [],
    CONTENT:     [],
    URL:         [],
    META:        [],
  },
  SETTINGS:           {
    STYLE: {
      TABS:    'TABS',
      BUTTONS: 'BUTTONS',
      SELECT:  'SELECT',
    },
  },
  ALLOWED_COMPONENTS: {
    BUTTON_TABS,
    COUNTER_BLOCK,
    COLLAPSED_BLOCK,
    CARD,
    DELIMITER_BLOCK,
    DOWNLOADABLE_CARD_BLOCK,
    DOOR_SLIDER,
    HIGHLIGHTED_BLOCK,
    IMAGE_GALLERY,
    IMAGE,
    GRID,
    STB,
    TEXT_BLOCK,
    TEXT_WITH_IMAGE,
    TILES,
    YOUTUBE_VIDEO,
  },
};

export const TRADE_STORES = {
  LABEL:    'TRADE_STORES',
  SETTINGS: {
    BACKGROUND_COLOR: null,
  },
  FIELDS:   {
    IMAGE: [],
    ALT:   '',
    LINK:  '',
  },
};

TABS_WITH_ROUTER.ALLOWED_COMPONENTS = {
  ...TABS_WITH_ROUTER.ALLOWED_COMPONENTS,
  TABS_WITH_ROUTER,
};
BUTTON_TABS.ALLOWED_COMPONENTS      = {
  ...BUTTON_TABS.ALLOWED_COMPONENTS,
  TABS_WITH_ROUTER,
  BUTTON_TABS,
};

export const staticPageConstants = {
  PAGE_TYPE:           {
    STATIC_PAGE:         'STATIC_PAGE',
    TABS_WITH_SCROLLING: 'TABS_WITH_SCROLLING',
    BASE_TABS:           'BASE_TABS',
  },
  COMPONENTS:          {
    BUTTON_TABS,
    COUNTER_BLOCK,
    CARD,
    CITIES_BLOCK,
    COLLAPSED_BLOCK,
    DELIMITER_BLOCK,
    DOOR_SLIDER,
    DOWNLOADABLE_CARD_BLOCK,
    HIGHLIGHTED_BLOCK,
    IMAGE,
    IMAGE_GALLERY,
    GRID,
    TEXT_BLOCK,
    TILES,
    TABS,
    TABS_WITH_ROUTER,
    TEXT_WITH_IMAGE,
    STB,
    YOUTUBE_VIDEO,
  },
  OPTIONAL_COMPONENTS: {
    TRADE_STORES,
  },
};